import {t} from '../../../common/getTranslations';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {Control} from '../../molecules/Control/Control';
import {ViewerSettingLineGapProps} from './ViewerSettingLineGapProps.interface';
import {ViewerSettingScrollableItem} from './ViewerSettingScrollableItem';

export function ViewerSettingLineGap({
  isMobile,
  currentLineGap,
  onClickLineGapMinus = () => {},
  onClickLineGapPlus = () => {},
  isLineGapMinusDisabled = false,
  isLineGapPlusDisabled = false,
}: ViewerSettingLineGapProps) {
  return (
    <ViewerSettingScrollableItem
      isMobile={isMobile}
      title={t('viewer_setting_interval')}
      className={isMobile ? 'mt-6pxr' : 'mt-10pxr'}
    >
      <Control
        count={currentLineGap}
        onClickMinus={e =>
          LOG_CLICK_EVENT('줄간격_클릭', e, onClickLineGapMinus)
        }
        onClickPlus={e => LOG_CLICK_EVENT('줄간격_클릭', e, onClickLineGapPlus)}
        isMinusDisabled={isLineGapMinusDisabled}
        isPlusDisabled={isLineGapPlusDisabled}
        isLoggingZoom
      />
    </ViewerSettingScrollableItem>
  );
}
